import { httpclient } from '@/api/brainstorm/client';
import { isNullOrUndefined } from 'shared/lib/object/object';

export const stopChat = (chatId) => httpclient.post('/stop', { chatId });

// an EventSource sends no custom headers, so the tenant travels in the query
export const chatStreamURL = (chatId, tenantId) => {
  const url = new URL(`${httpclient.defaults.baseURL}/stream`);
  url.searchParams.set('chatId', chatId);
  if (!isNullOrUndefined(tenantId)) {
    url.searchParams.set('tenantId', tenantId);
  }
  return url.toString();
};
